import React, {useState} from 'react'
import Img from "gatsby-image"
import Reactmarkdown from "react-markdown/with-html"
import { Modal } from "react-bootstrap"

const Charger = ({ data: {
    producer, model, image:foto, plug:wtyk, power:moc
} }) => {

    const [show, setShow] = useState(false);
    const [pic, setPic] = useState('');

    const handleClose = () => {
        setShow(false);
    }
    const handleShow = (pic) => {
        setPic(pic);
        setShow(true);
    }


    return (
      <>
        <div className="row">
          <div className="col-12 col-md-4">
            <Img
              fluid={foto.childImageSharp.fluid}
              className="img-fluid rounded-xxl"
              alt={model}
            />
          </div>
          <div className="col-12 col-md-8 mt-4 mt-md-0">
            <div className="charger-title d-flex flex-column flex-lg-row">
              <p>
                Model: <strong>{model}</strong>
              </p>
              <p>
                Manufacturer: <strong>{producer}</strong>
              </p>
            </div>
            <p>Available connectors:</p>
            <div className="row">
              {wtyk.map((item, i) => {
                return (
                  <div
                    className="col-12 col-lg-4 mb-3 mb-lg-0"
                    key={`zlacze-${i}`}
                  >
                    <div className="box">
                      <button
                        className="mb-3 button-blank"
                        onClick={handleShow.bind(this, {
                          fotka: item.modalimage.childImageSharp.fluid,
                          nazwa: item.name,
                        })}
                      >
                        <Reactmarkdown source={item.icon} escapeHtml={false} />
                      </button>
                      <p className="font-bold">{item.name}</p>
                      <p>{item.desc}</p>
                    </div>
                  </div>
                )
              })}
            </div>
            <p className="mt-4">Power:</p>

            {moc.map((item, i) => {
              return (
                <div
                  className="d-flex my-3 align-items-start align-items-md-center flex-column flex-md-row"
                  key={`moc-${i}`}
                >
                  <div className="moc">
                    {item.power} <span>kW</span>
                  </div>
                  <div className="charger-types d-flex">
                    {item.chargertype.map((item, i) => {
                      return (
                        <div className="charger-type" key={`chargertype-${i}`}>
                          <div className="big">{item.powertype}</div>
                          <div className="small">{item.plug}</div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              )
            })}

            <div className="mt-5">
              <a
                href="https://www.orlen.pl/en/for-you/fuel-stations?kw=&from=&to=&s=1669&wp=&dst=0"
                target="_blank"
                rel="noreferrer"
                className="link-more"
                title="Locate on the map"
              >
                Locate on the map
              </a>
            </div>
          </div>
        </div>

        <Modal
          show={show}
          onHide={handleClose}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{pic.nazwa}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {pic.fotka ? <Img fluid={pic.fotka} title={pic.nazwa} /> : ""}
          </Modal.Body>
        </Modal>
      </>
    )
}

export default Charger
